import { Model } from '@vuex-orm/core'

class WheelPlayer extends Model {
  static entity = 'wheel-players'

  static fields() {
    return {
      id: this.string(null),
      user: this.attr({}),
      bets: this.attr({}),
      betSum: this.number(),
    }
  }

  static beforeCreate(model) {
    model.betSum = Object.values(model.bets).reduce((acc, v) => acc + v, 0)
  }

  static beforeUpdate(model) {
    model.betSum = Object.values(model.bets).reduce((acc, v) => acc + v, 0)
  }
}

export default WheelPlayer
